export enum FieldCategoryGroups {
    VENDOR = 'Vendor Fields',
    CUSTOM = 'Custom Fields',
}
